import { defineStore } from 'pinia'
export const useSocketStore = defineStore('socket', {
  state: () => ({
    temps: 0,
    status: 'connecting'
  }),
  getters: {
    getConnectingTimes(state) {
      return state.temps
    },
    getStatus(state) {
      return state.status
    }
  },
  actions: {
    setStatus(status) {
      this.status = status
    },
    setConnectingTimes() {
      this.temps += 1
    },
    reset() {
      this.$reset()
    }
  }
})
